var Glass_module_default = { glass: "_glass_sepwu_8" };
//#endregion
export { Glass_module_default as default };

//# sourceMappingURL=Glass.module.js.map